var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-container flex-row"},[_c('div',{staticClass:"side-wrapper"},[_c('app-sidebar')],1),_vm._v(" "),_c('div',{staticClass:"app-wrapper flex-col"},[_c('app-navbar'),_vm._v(" "),_c('app-main')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bd3543b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/index.vue
// module id = null
// module chunks = 